<template>
	<div></div>
</template>

<script>
	import {
		getItem,
		removeToken,
		removeItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				socket: null,
				timeoutObj: null,
				timeout: 30 * 1000,
				socketUrl: "",
				timeEnd: 0
			}
		},
		props: ['nowTime'],
		mounted() {
			let that = this
			// that.socketUrl = 'ws://192.168.31.211:10100/imserver/' + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' + getItem('userInfo').tenantInfoId
			that.socketUrl = config.socketUrl + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' +
				getItem('userInfo').tenantInfoId
			that.initWebSocket(that.socketUrl)
		},
		methods: {
			initWebSocket(url) {
				this.timeEnd++;
				if (this.timeEnd > 3) {
					this.outFun()
				} else {
					if (typeof WebSocket === 'undefined') {
						alert('您的浏览器不支持socket')
					} else {
						this.socket = new WebSocket(url)
						this.socket.onopen = this.open
						this.socket.onerror = this.error
						this.socket.onmessage = this.getMessage
						this.socket.onclose = this.websocketclose
					}
				}
			},
			open() {
				var self = this
				self.timeoutObj = window.setInterval(function() {
					if (self.socket.readyState === 1) {
						self.socket.send('heartCheck')
					}
				}, self.timeout)
			},
			error() {
				this.outFun()
			},
			getMessage(event) {
				let that = this
				if (event.data !== '连接成功') {
					let socketData = JSON.parse(event.data)
					if (socketData.socketType !== '5') {
						that.$emit('backSockertData', socketData)
					}
				}
			},
			websocketclose() {
				let self = this
				window.clearInterval(self.timeoutObj)
				self.socket = null
				self.initWebSocket(self.socketUrl)
			},
			outFun() {
				let that = this
				window.clearInterval(self.timeoutObj)
				self.socket = null
				if (document.getElementsByClassName("el-notification right").length === 0) {
					that.$notify.warning({
						title: languageJson.logInAgain
					})
					setTimeout(() => {
						removeToken()
						removeItem('differtime')
						that.$router.push({
							name: 'login',
						})
					}, 2000)
				}
			}
		},
		destroyed() {
			let that = this
			window.clearInterval(that.timeoutObj)
			that.socket = null
		}
	}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/IndexSocket.vue